import {ajaxGet} from '../shared/ajax';

const initSearchWhisperer = () => {
    //there are multiple. Desktop and mobile
    const whisperers = document.querySelectorAll('.search-whisperer')
    whisperers.forEach(whisperer => {

        const input = whisperer.querySelector('input');
        if (input) {

            //save recent query on submit
            whisperer.addEventListener('submit', e => {
                saveRecentQuery(input.value)
            });

            //save recent query on click tranding
            const trendingItems = whisperer.querySelectorAll('.search-whisperer-trending .search-box__item')
            if(trendingItems){
               trendingItems.forEach(trendingItem => {
                   trendingItem.addEventListener('click', e => {
                       saveRecentQuery(trendingItem.innerText)
                   })
               })
            }

            //on keyup process ajax, show and hide
            input.addEventListener('keyup', delay(e => {
                e.preventDefault();
                if(e.key !== 'Escape'){
                    if(input.value.length > 1){
                        hideTrendingQueries(whisperer)
                        hideResultList(whisperer)
                        showResultListPlaceholder(whisperer)
                        showWhisperer(whisperer)
                        const link = input.getAttribute('data-whisperer-url') + '?q=' + input.value;
                        ajaxGet({
                            url: link,
                            customCallback: function(response){
                                setResultsListHtml(whisperer, response.html)
                                showResultList(whisperer)
                                hideResultListPlaceholder(whisperer)
                            },
                            processSuccessCallback: true
                        });
                    }
                    else {
                        if(hasTrandingQueries(whisperer)) {
                            showTrendingQueries(whisperer)
                            hideResultList(whisperer)
                            hideResultListPlaceholder(whisperer)
                            showWhisperer(whisperer)
                        }
                        else {
                            hideWhisperer(whisperer)
                        }
                    }
                }
            }, 600));

            //open whisperer on click
            input.addEventListener('click', e => {
                e.preventDefault();
                if(!isWhispererVisible(whisperer)){
                    if(input.value.length > 1){
                        showWhisperer(whisperer)
                    }
                    else{
                        if(hasTrandingQueries(whisperer)){
                            showTrendingQueries(whisperer)
                            hideResultListPlaceholder(whisperer)
                            hideResultList(whisperer)
                            showWhisperer(whisperer)
                        }
                    }
                }
            });
        }

    });


    //recent
    if(hasRecentQueries()){
        appendRecentQueriesToWhisperers()
        showRecentQueries()
    }
    const recentCLearButtons = document.querySelectorAll('.search-whisperer-recent .recent-clear-all')
    if(recentCLearButtons){
        recentCLearButtons.forEach(recentCLearButton => {
            recentCLearButton.addEventListener('click', e => {
                e.preventDefault();
                removeRecentQueries()
                hideRecentQueries()
            })
        })
    }

    //close on escape press
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            whisperers.forEach(whisperer => {
                if (isWhispererVisible(whisperer)) {
                    e.preventDefault();
                    hideWhisperer(whisperer)
                }
            })
        }
    });

    //close on click outside
    document.addEventListener('click', e => {
        whisperers.forEach(whisperer => {
            if(e.target.classList.contains('recent-remove') || e.target.closest('.recent-remove')){
                return;
            }
            if (isWhispererVisible(whisperer) && e.target.closest('.search-whisperer') === null) {
                hideWhisperer(whisperer)
            }
        })
    });
}


const showResultList = (whisperer) => {
    const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-result-list')
    if(element){
        element.style.display = 'block';
    }
}
const setResultsListHtml = (whisperer, html) => {
    const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-result-list');
    element.innerHTML = html;
}
const hideResultList = (whisperer) => {
    const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-result-list')
    if(element){
        element.style.display = 'none';
    }
}



const showResultListPlaceholder = (whisperer) => {
    const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-result-placeholder')
    if(element){
        element.style.display = 'block';
    }
}
const hideResultListPlaceholder = (whisperer) => {
    const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-result-placeholder')
    if(element){
        element.style.display = 'none';
    }
}
const showTrendingQueries = (whisperer) => {
    const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-trending')
    if(element){
        element.style.display = 'block';
    }
}
const hasTrandingQueries = (whisperer) => {
    const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-trending')
    if(element){
        return true;
    }
    return false;
}
const hideTrendingQueries = (whisperer) => {
    const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-trending')
    if(element){
        element.style.display = 'none';
    }
}

const isWhispererVisible = (whisperer) => {
    const element = whisperer.querySelector('.search-whisperer-result')
    if(element){
        return element.style.display === 'block';
    }
    return false
}
const hideWhisperer = (whisperer) => {
    whisperer.classList.remove('search--active')
    const element = whisperer.querySelector('.search-whisperer-result')
    if(element){
        element.style.display = 'none';
    }
}
const showWhisperer = (whisperer) => {
    whisperer.classList.add('search--active')
    const element = whisperer.querySelector('.search-whisperer-result')
    if(element){
        element.style.display = 'block';
    }
}


// recent queries
const showRecentQueries = () => {
    const whisperers = document.querySelectorAll('.search-whisperer')
    if(whisperers){
        whisperers.forEach(whisperer => {
            const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-recent')
            if(element){
                element.style.display = 'block';
            }
        })
    }
}
const hideRecentQueries = () => {
    const whisperers = document.querySelectorAll('.search-whisperer')
    if(whisperers){
        whisperers.forEach(whisperer => {
            const element = whisperer.querySelector('.search-whisperer-result .search-whisperer-recent')
            if(element){
                element.style.display = 'none';
            }
        })
    }
}

const saveRecentQuery = (text) => {

    const recentQueries = JSON.parse(localStorage.getItem('recentQueries')) || [];

    text = text.toLowerCase();
    const index = recentQueries.indexOf(text);
    if (index > -1) {
        recentQueries.splice(index, 1);
    }
    recentQueries.unshift(text);
    if (recentQueries.length > 10) {
        recentQueries.pop();
    }
    localStorage.setItem('recentQueries', JSON.stringify(recentQueries));
}
const getRecentQueries = () => {
    const recentQueries = JSON.parse(localStorage.getItem('recentQueries')) || [];
    return recentQueries;
}
const hasRecentQueries = () => {
    return getRecentQueries().length > 0;
}
const appendRecentQueriesToWhisperers = () => {
    const whisperers = document.querySelectorAll('.search-whisperer')
    if(whisperers) {
        whisperers.forEach(whisperer => {
            const recentQueryTemplate = whisperer.querySelector('.search-whisperer-result .search-whisperer-recent .recent-template');
            if(recentQueryTemplate){
                getRecentQueries().forEach(query => {
                    const clone = recentQueryTemplate.cloneNode(true);
                    clone.classList.remove('recent-template');
                    clone.querySelector('.recent-text').innerText = query;
                    clone.href = clone.getAttribute('href') + query;
                    clone.removeAttribute('style');
                    clone.querySelector('.recent-remove').addEventListener('click', e => {
                        e.preventDefault();
                        removeRecentQuery(query);
                        if(getRecentQueries().length === 0){
                            hideRecentQueries(whisperer)
                        }
                    })
                    recentQueryTemplate.parentNode.append(clone);
                });
            }
        })
    }
}
const removeRecentQuery = (text) => {
    const recentQueryElements = document.querySelectorAll('.search-whisperer-recent .search-box__item:not(.recent-template)');
    if(recentQueryElements){
        recentQueryElements.forEach(recentQueryElement => {
            if (recentQueryElement.querySelector('.recent-text').innerText === text) {
                recentQueryElement.remove();
            }
        })
    }

    const recentQueries = getRecentQueries()
    const index = recentQueries.indexOf(text);
    if (index > -1) {
        recentQueries.splice(index, 1);
    }
    localStorage.setItem('recentQueries', JSON.stringify(recentQueries));
}
const removeRecentQueries = () => {
    const recentQueryElements = document.querySelectorAll('.search-whisperer-recent .search-box__item:not(.recent-template)');
    if(recentQueryElements){
        recentQueryElements.forEach(recentQueryElement => {
            recentQueryElement.remove();
        })
    }
    localStorage.removeItem('recentQueries');
}


const delay = function (callback, ms) {
    let timer = 0;

    return function () {
        let context = this, args = arguments;

        clearTimeout(timer);

        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

export default initSearchWhisperer;